import styled from 'styled-components';

export const LabelBg = styled.span`
  line-height: ${({ lineheight }) => (lineheight ? lineheight : '17px')};
  font-size: ${({ size }) => (size ? size : '14px')};
  font-family: ${({ altFont }) => (altFont ? 'Roboto' : 'Noto Sans')};
  font-weight: ${({ weight }) => (weight ? weight : 'bold')};
  background-color: ${({ bgColor }) => (bgColor ? bgColor : 'none')};
  width: ${({ width }) => (width ? width : '100%')};
  height: ${({ height }) => (height ? height : '100%')};
  color: ${({ theme, color }) => (color ? color : theme.white)};
  margin-bottom: ${({ mb }) => (mb ? mb : '8px')};
  margin-top: ${({ mt }) => (mt ? mt : '0')};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`